import type { Address } from "~/types/address";

export const formatAddressWithPincode = (address: Address | null) => {
    if (!address) return "";

    const { address_line2, address_line3, area_code, city, formatted_address } = address;

    const main = address_line3 || address_line2 || city?.name || "";

    return area_code ? `${main} ${area_code}` : formatted_address;
};